import { zergApi } from "@/service/zerg";

class GeneralService {
    async getModules(params) {
        try {
            return [];
        } catch (error) {
            throw error;
        }
    }

    async getNotifications(params){
        try {
            const data = await zergApi.post("/commons/notifications/get-notifications",params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async getAllNotifications(params){
        try {
            const data = await zergApi.post("/commons/notifications/get-all-notifications",params);
            return data;
        } catch (error) {
            throw error;
            
        }
    }
};

export default new GeneralService();